import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminCampaignsState } from './types';
import { CampaignConfig, GetCampaignConfigsParams } from '../types';

const initialState: AdminCampaignsState = {
  campaignConfigs: [],
  isLoading: false,
  error: null,
  totalCount: 0,
  filters: {
    limit: 25,
    offset: 0,
    query: undefined,
    types: undefined,
    statuses: 'active,archived',
    applicationIds: undefined,
    categories: undefined,
  },
};

const adminCampaignsSlice = createSlice({
  name: 'adminCampaigns',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCampaignConfigs: (state, action: PayloadAction<{ items: CampaignConfig[]; count: number }>) => {
      state.campaignConfigs = action.payload.items;
      state.totalCount = action.payload.count;
    },
    updateFilters: (state, action: PayloadAction<Partial<GetCampaignConfigsParams>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    deleteCampaignConfig: (state, action: PayloadAction<string>) => {
      state.campaignConfigs = state.campaignConfigs.filter(config => config.id !== action.payload);
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
  },
});

export const { setLoading, setError, setCampaignConfigs, updateFilters, deleteCampaignConfig } = adminCampaignsSlice.actions;
export default adminCampaignsSlice.reducer;
